// (c) chaehongee. Confidential and proprietary.

import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from './hooks'
import {
    restoreFromStorage,
    SESSION_TABS_STORAGE_KEY,
    type SessionTabsPersistedStateV1,
} from '../slices/sessionTabsSlice'

export function useSessionTabsPersistence(): void {
    const dispatch = useAppDispatch()
    const openSessionIds = useAppSelector((s) => s.sessionTabs.openSessionIds)
    const activeSessionId = useAppSelector((s) => s.sessionTabs.activeSessionId)
    const hasRestoredRef = useRef(false)

    // One-time restore
    useEffect(() => {
        if (hasRestoredRef.current) return
        hasRestoredRef.current = true
        try {
            const raw = window.localStorage.getItem(SESSION_TABS_STORAGE_KEY)
            if (!raw) return
            const parsed = JSON.parse(raw) as SessionTabsPersistedStateV1
            if (!parsed || parsed.version !== 1) return
            dispatch(restoreFromStorage(parsed))
        } catch {
            // Best-effort: ignore invalid storage payloads
        }
    }, [dispatch])

    // Persist on change (best-effort)
    useEffect(() => {
        if (!hasRestoredRef.current) return
        const payload: SessionTabsPersistedStateV1 = {
            version: 1,
            openSessionIds,
            activeSessionId,
        }
        try {
            window.localStorage.setItem(SESSION_TABS_STORAGE_KEY, JSON.stringify(payload))
        } catch {
            // Best-effort: ignore quota/unavailable storage
        }
    }, [openSessionIds, activeSessionId])
}

